"use client";

// ReadingBar — how far you are through THIS document, sitting directly under its
// title and exactly as wide as the title is.
//
// It replaces the full-width scrubber that used to run above the reader: a bar
// spanning the whole window read as chrome and told you nothing about the thing
// you were reading. Tied to the title, it belongs to the document.
//
// PERFORMANCE IS THE POINT. The fill is a `scaleX` on a ref — never React state
// — so scrolling a document re-renders nothing at all; the transform is
// compositor-only, and the easing is a CSS transition on that transform, which
// means the bar catches up on a curve instead of jittering with every scroll
// event. (The old bar animated `width`, which relayouts on every frame.)

import { useEffect, useRef } from "react";

export default function ReadingBar({ docKey }: { docKey: string }) {
  const fillRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const on = (e: Event) => {
      const p = (e as CustomEvent<number>).detail;
      const v = Math.max(0, Math.min(1, typeof p === "number" ? p : 0));
      // scaleX from the left edge — one compositor property, no layout, no paint.
      fillRef.current?.style.setProperty("--art-read", v.toFixed(4));
    };
    window.addEventListener("innernet:art-read", on as EventListener);
    return () => window.removeEventListener("innernet:art-read", on as EventListener);
  }, []);

  // a fresh document starts unread.
  useEffect(() => {
    fillRef.current?.style.setProperty("--art-read", "0");
  }, [docKey]);

  return (
    <div className="art-read" aria-hidden>
      <i ref={fillRef} />
    </div>
  );
}
